export default {
  leftNav: {
    nav0: "概览",
    nav1: "特色",
    nav2: "功能亮点",
    nav3: "应用场景",
    nav4: "更多信息",
    nav5: "资料下载",
    nav6: "联系我们",
    nav7: "服务支持",
  },
  FreeDemo: "免费试用",
  ContactUs: "联系我们",
  Download: "下载",
  Videos: "视频",
  accessories: "产品配件",
  similarProducts: "类似产品",
  ContactBrUs: "联系我们",
  DownloadBrCenter: "下载中心",
  FAQ: "热门问答",
  ten: {
    Frictionless: "无障碍沟通",
    Augmented: "无缝同步连接",
    Conference: "别样用户体验",
    Enhanced: "高性能高效率",
    Seemless: "随时随地畅享通话",
  },
  message: "简要描述您的需求",
  Oldest: "近期",
  Recentness: "往期",
  ViewMore: '滑动查看更多',
};
